import React from 'react';
import img1 from '../../../../../img/how-it-works-assessment-signature/book-tutorial-img.png';
import img2 from '../../../../../img/how-it-works-assessment-signature/plan-evidence-img.png';
import img3 from '../../../../../img/how-it-works-assessment-signature/film-evidence-img.png';
import img4 from '../../../../../img/how-it-works-assessment-signature/upload-evidence-img.png';
import img5 from '../../../../../img/how-it-works-assessment-signature/eportfolio-img.png';
import img6 from '../../../../../img/how-it-works-assessment-signature/qualification-male.png';

const SignatureEvidence = () => (
  <div className='l-container l-container--x-narrow'>
    <ul className='progression-list'>
      <li className='island island--outline js-inview is-inview'>
        <h2>1. Book Tutorial</h2>
        <img src={img1} alt='Book tutorial' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>2. Plan evidence with assessor</h2>
        <img src={img2} alt='Plan evidence' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>3. Film evidence</h2>
        <img src={img3} alt='Film evidence' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>4. Upload evidence to your e-portfolio</h2>
        <img src={img4} alt='Upoad evidence' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>5. Assessor sends e-portfolio to Signature</h2>
        <img src={img5} alt='Evidence to signature' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>6. Qualification!</h2>
        <img src={img6} alt='Qualification' />
      </li>
    </ul>
  </div>
);

export default SignatureEvidence;



// WEBPACK FOOTER //
// ./src/views/Main/Tour/AssessmentAndEvidences/SignatureEvidence/index.js